<template>
<div id="ServiceCodeToothNumberAllowed">
<b-modal id="ServiceCodeToothNumberAllowedAddEdit"  v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close hide-footer
         header-class="PopUpHeader" 
          :header-text-variant=PopUpVar.headerTextVariant
          :body-bg-variant=PopUpVar.bodyBgVariant
          :body-text-variant=PopUpVar.bodyTextVariant
          :footer-bg-variant=PopUpVar.footerBgVariant
          :footer-text-variant=PopUpVar.footerTextVariant> 
        <ServiceCodeToothNumberAllowedAddEdit  v-if="showEditModal==true" :UserData="UserData" :UserRow="editedRow" :DataSet="tableData" :mode="mode" @ServiceCodeToothNumberUpdate="UpdateRecord"></ServiceCodeToothNumberAllowedAddEdit>
        
        <template slot="modal-header" > 
            <div>
            <small class="modal-title PopUpTitle w-100 text-left">{{mode}} Tooth Number Allowed</small>
          </div> 
          <div v-show="mode=='Edit'"><small class="modal-title w-100 text-right"></small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
      </b-modal> 

  <div  class="row " >
    <div class="col-5">
      <label for="VueTables_Adduser" class="VueTables_user small">Specific Tooth Number Allowed:</label>
      <div slot="beforeBody"  class="VueTables_Adduser small">
        <button :disabled="readonly || maxRows || !allowadd" v-on:click="AddPrereqServiceCodesPopup()" type="button"  class="btn btn-primary btn-smlb">Add Tooth Number</button>
      </div>
    </div>
    <div class="col-7">
      <v-client-table class="small" :columns="columns" :data="tableData" :options="options">
        <span class="pointer" v-on:click="DeleteRecordMsgBox('Are you sure you want to delete this tooth number?','Please Confirm',props)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
        <span class="pointer" v-on:click="EditToothNumberAllowedPopup(props)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
      </v-client-table> 
    </div>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ServiceCodeToothNumberAllowedAddEdit from '@/components/DPEBB/Administrator/ServiceCodeToothNumberAllowedAddEdit.vue';
const MaxNumTeeth = 20

export default {
props:{
      Data:'',
      ReadOnly:false,
      AllowAdd:''
    },
     data: function(){
        return {
           
            maxRows :false,
            PopUpVar:PopUpVariant,
            showModal:false,
            isValid:false,
            Access:'',
            // AllowAdd:false,
            showEditModal:false,
            isValid:'',
            Button:'',
            readonly:false,
            editedRow:'',
            mode:'',
            allowadd:'',
        columns: ['delete','edit','tooth'],
        tableData: [],
        options: {
          skin:"table-striped table-bordered table-hover",
        texts:{
              count:"",
              first:'First',
              last:'Name',
              filter:"",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         footerHeadings :false,
          perPage:20,
          perPageValues:[30,35,40],
          toMomentFormat: 'YYYY-MM-DD', 
          headings: {
            tooth: 'Tooth',
            edit:'',
            delete:''
          }, 
          sortable: ['tooth'],
           filterable: '', 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
        
        },
        components: {
          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ServiceCodeToothNumberAllowedAddEdit
        
        },
        created:function(){ 
            this.tableData = this.Data; 
            this.readonly = this.ReadOnly;
            if(this.AllowAdd =='1')
            {                 
                this.MaxNumTeeth = 20;
                this.allowadd=true;
                this.maxRows = this.tableData.length == MaxNumTeeth;
           }
            else if(this.AllowAdd =='2')
            {
                this.MaxNumTeeth = 20;
                this.allowadd=true;
            }
            else if(this.AllowAdd =='9')
            {
                this.MaxNumTeeth = 20;
                this.allowadd=true;
            }
            if(this.AllowAdd =='N')
            {
              this.allowadd=false;
            }
        },
        mounted() {
            // hide admin column
            if (this.readonly) {
                  this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
        }
       
    },
    methods:{
      DeleteRecordMsgBox(msg,title, data){
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
        })
        .then(value => {
          this.boxTwo = value
          var vm = this;          
            if(value)
            {
              this.tableData.splice((data.index -1),1);
              this.maxRows = this.tableData.length == MaxNumTeeth;
            } 
        })
        .catch(err => {
          console.log(err);
        })
      },
      AddPrereqServiceCodesPopup(){
         this.mode='Add';
          this.editedRow = -1;
          this.UserData = '';
          this.showEditModal=true;
      },
      EditToothNumberAllowedPopup(Rowdata){
          this.editedRow = Rowdata.index -1;
          this.mode='Edit';
          this.UserData = Rowdata.row
          this.showEditModal=true;
      },
      showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            this.boxTwo = value
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
      UpdateRecord(value){
        this.showEditModal = false;
        if(this.editedRow != -1){
          this.tableData[this.editedRow].tooth = value;
        }
        else{ 
           console.log('max rows ' + this.maxRows)
            if( this.MaxNumTeeth ==  this.tableData.length)
              {
                this.readonly = true; 
              } 
              else
              {
                 this.tableData.push({tooth:value});
              }
          // if(this.AllowAdd == '1')
          // {
          //   var maxval = parseInt(this.AllowAdd);
          //   this.tableData.push({tooth:value});
          //   if( maxval ==  this.tableData.length)
          //     {
          //       this.readonly = true; 
          //     } 
          // }
          // else
          // {
          //   this.tableData.push({tooth:value});
          // }
        }
         this.maxRows = this.tableData.length == MaxNumTeeth;
      }

    }
}
</script>

<style scopped>
VuePagination__count{
  display: none;
}
#ServiceCodeToothNumberAllowed  .modal-dialog {
    max-width: 45%;
    margin: 0;
    top: 5%;
    bottom: 0;
    left: 20%;
    right: 20%;
    height: 25vh;
    display: flex;
    /* position: fixed; */
    z-index: 100000;
}
</style>
